import barracksApi from "@/api/barracksApi";
import { BarrackBookingDto } from "@/types/bookingInterface";

export default {
  namespaced: true,

  state: {
    bookingActive: {} as BarrackBookingDto,
    isBookingActive: false,
  },
  getters: {
    bookingActive: (state) => {
      return state.bookingActive;
    },
    isBookingActive: (state) => {
      return state.isBookingActive;
    },
  },
  mutations: {
    bookingActive(state, value: BarrackBookingDto) {
      state.bookingActive = value;
    },
    isBookingActive(state, value: boolean) {
      state.isBookingActive = value;
    },
  },
  actions: {
    async setBookingActive(context) {
      await barracksApi.getBookingActiveBarracks().then((res) => {
        context.commit("bookingActive", res);
        context.commit("isBookingActive", Object.keys(res).length > 0);
      });
    },
  },
};
